import React, {FC} from "react";
import {IFormItem} from "../Types";
import {Form, Input} from "antd";

export const __FormInput: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
            hidden={props.hidden}
        >
            <Input
                allowClear={props.allowClear} disabled={props.disable} placeholder={props?.placeholder}/>
        </Form.Item>
    )
}